module.exports = __webpack_public_path__ + "img/share.ac1ce669.jpg";